var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCw05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.226 6.44652C10.0871 7.75147 9.3477 8.97433 8.12421 9.68072C6.09147 10.8543 3.49221 10.1579 2.3186 8.12511L2.1936 7.9086M1.77258 5.5535C1.91148 4.24855 2.65087 3.02569 3.87437 2.31931C5.90711 1.1457 8.50637 1.84217 9.67997 3.87492L9.80497 4.09142M1.74609 9.03303L2.11212 7.667L3.47814 8.03303M8.52071 3.967L9.88673 4.33303L10.2528 2.967",
    stroke: "#414651",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw05);
export default __webpack_public_path__ + "static/media/refresh-cw-05.04092159fca04152f3fb54432bd5ba6c.svg";
export { ForwardRef as ReactComponent };